import { gql } from '@apollo/client'

export type ClosePendingActionRequestInput = {
  input: {
    dealId: number
    reasonCode: string
    closeReasonCode: string
    employeeNumber: number
    approvalStatusType: string
    approvalStatusComment: string
    approvalFlowLevel?: number | null
    authBenchmark?: string
    adjustmentPercentage?: number
  }
}

export type DecisionActionResponse = {
  closePendingAction: {
    didError: boolean
    errorMessage: string
    warningMessage: string
    deal: {
      bdId: number
      dealVersionNr: number
      dealNumber: number
    }
    isLastLevel: boolean
  }
}

export const SAVE_COMMENT = gql`
  mutation SaveComment($input: ClosePendingActionRequestInput) {
    closePendingAction(input: $input) {
      didError
      errorMessage
      warningMessage
      isLastLevel
      deal {
        bdId
        dealVersionNr
        dealNumber
      }
    }
  }
`
